import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { GamesGroupState, GamesGroupStore } from './games-group.store';
import { IGroupSummary } from './new-models/IGroupSummary';
import { PredictorGroupSummary } from './new-models/PredictorGroupSummary';
import { ProgressStatus } from './new-models/ProgressStatus';
import { PredictorProcessStatus } from './models/games-predictor-process-status.enum';

@Injectable({ providedIn: 'root' })
export class GamesGroupQuery extends QueryEntity<GamesGroupState> {
  constructor(protected store: GamesGroupStore) {
    super(store);
  }

  getPredictorFinalStatus(gameGroupItemSummary: IGroupSummary): { label: string; class: string; value: string } {
    const gameGroupItem = gameGroupItemSummary as PredictorGroupSummary;

    const isCompleted = gameGroupItem.Status === ProgressStatus.Completed;
    const isNotStarted = gameGroupItem.Status === ProgressStatus.NotStarted;
    const isReady = gameGroupItem.ProcessStatus === PredictorProcessStatus.Ready;
    const isProcessed = gameGroupItem.ProcessStatus === PredictorProcessStatus.Processed;
    const isProcessing = gameGroupItem.ProcessStatus === PredictorProcessStatus.Processing;
    const isPastEndDate = this.checkEndDate(String(gameGroupItem.EndDate), String(gameGroupItem.RequestTime));

    if (isCompleted && isReady && !isPastEndDate) {
      return {
        label: 'fgbcl.game.predictor.resume.button.text',
        class: 'game-resume-button',
        value: 'resume',
      };
    } else if (isCompleted && isProcessed) {
      return {
        label: 'fgbcl.game.predictor.view.button.text',
        class: 'game-view-button',
        value: 'completed',
      };
    } else if (isNotStarted && isReady) {
      return {
        label: 'fgbcl.game.predictor.play.button.text',
        class: 'game-play-button',
        value: 'play',
      };
    } else if ((isCompleted && isProcessing) || (!isNotStarted && isPastEndDate)) {
      return {
        label: 'fgbcl.game.predictor.processing.button.text',
        class: 'game-pending-result-button',
        value: 'processing',
      };
    } else {
      return {
        label: 'fgbcl.game.predictor.play.button.text',
        class: 'game-play-button',
        value: 'play',
      };
    }
  }

  checkEndDate(endDateStr: string, requestTimeStr: string): boolean {
    const endDate = new Date(endDateStr);
    const requestTime = new Date(requestTimeStr);
    return requestTime > endDate;
  }
}
